import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import { Main, Section } from "./SelectFunction.style";
import { Box } from "@mui/material";
import { Icon } from "assets/Icons_";
import { get, getFocus, useAtom, useGet, useSet } from "state/jotai";
import { active_project, iconRotate, iso_free, iso_isrotating, seasonMode, turn_building, vis_showOldSlider, weaterMode } from "state/store.global";
import { ShiftProperty } from "components/ShiftProperty/ShiftProperty";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { _bootstrap } from "state/store.bootstrap";
import { useBreak } from "hooks/useBreak";
import { getIsoData } from "state/jotai.isometryDataHooks";
import { Status } from "components/StatusPopup/StatusPopup";
import { _project } from "state/store.projects";
import { DesktopColorLegend } from "components/ColorLegend/DesktopColorLegend";
import { ColorLegend } from "components/ColorLegend/ColorLegend";
import { FooterButton } from "components/DualMenu/DualMenu.style";
import { ETStyledButton } from "components/Button/EusButton";
import { SelectWeatherMobile } from "components/SunDiagram/SeletWeatherMobile";
import styled from "styled-components";


export const SelectFunction = ({ clickModel, showSelectFunction, setShowSelectFunction,rotatemode,isrotate,click1,click2,turnBuilding}) => {
  const [showProperty, setShowProperty] = useState(false);
  const [iconRotated, setIconRotated]   = useAtom(iconRotate)
    const [isSeasonModeOn, setSeasonMode] = useAtom(seasonMode);
    const setWeatherMode = useSet(weaterMode);
    const setRmode = useSet(iso_free)
    const setIsrotate = useSet(iso_isrotating)
  
  const { pin, pid } = useGet(active_project);
 
  const config            = getIsoData('config');
  const showOldSlider     = useGet(vis_showOldSlider);
  const here              = useLocation().pathname;
  const atModel           = here.includes("isometry");
  
  const projectType       = getFocus(_bootstrap, "type");
  const isMobile          = useBreak("md_dn");
  const [state, setState] = useState(false);
  const percent           = getIsoData("percent");
  const [, setIsTurnBuilding] = useAtom(turn_building);


  const raw = get(_project, 'unitsraw', 'Units') 
  
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const showButton = [
    "list",
    "compare",
    "favorites",
    "gallery",
    "downloads",
  ].some((i) => here.includes(i));

  const animation = {
    initial   : { opacity: 0 },
    animate   : { opacity: 1 },
    exit      : { opacity: 0 },
    transition: { duration: 0.5, ease: "linear" },
  };
  
  return (
    <>
      <AnimatePresence exitBeforeEnter>
      <ShiftProperty key='select-function-shift-property'
                          showProperty    = {showProperty}
                          setShowProperty = {setShowProperty}
                          setShowSelectFunction={setShowSelectFunction}
                      />
        {!state && showSelectFunction && (
          <>
            <Main isMobile={isMobile} as = {motion.div} {...animation} clr = {clr}>
              <Box
                sx={{
                  color         : "#fff",
                  borderBottom  : `1px solid ${clr.primary_text}`,
                  display       : "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box  sx        = {{ display:"flex", flexDirection:"column", justifyContent:"center", width: "100%", padding:  "16px 16px 16px 48px" }}>
                <Box  sx        = {{ display: "flex", justifyContent: "center",  color: clr?.primary_text }}>
                <span className = "h5"> { buttonsLabel?.filter( btn => btn.UILabelProperty === "VælgFunktion")[0]?.Label }</span>
                  </Box>
                </Box>
                <Box
                className="icon-hover-effect"
                  sx      = {{ padding: "16px" }}
                  onClick = {(e) => {
                    
                    const buttons = document.querySelectorAll('button, div[role="button"]');
                      buttons.forEach(button => button.blur());
                    setTimeout(() => {
                      setShowSelectFunction(false)
                    }, 100);
                  }}
                >
                  <Icon icon = {"close"} size = "xl" isFaIcon = {true} color = {clr?.primary_text } skipColorChange={true}/>
                </Box>
              </Box>
              <Box sx = {{padding:"16px" }}>
              <Box sx = {{display:"flex", flexDirection:"column", gap:"16px"}}>
                {
                   !rotatemode &&
                  <>
                  { projectType === "poly" && isMobile && 
                    <ETStyledButton
                    variant  = {"secondary-1st-varient"}
                    tabIndex = {"0"}
                    role     = "button"
                    pin      = {pin}
                    onClick  = {() => {
                          setShowProperty(!showProperty);
                          setShowSelectFunction(false);
                            // toggleDrawer();
                      }}
                      clr        = {clr}
                      showButton = {showButton}
                      >
                      <Icon
                          icon     = "buildings"
                          size     = "lg"
                          color    = {pin > 0 || showButton ? "#004337" : "#004337"}
                          isFaIcon = {true}
                          skipColorChange={true}
                      />
                      <div className = "eus-button-2"  style = {{ color: "#004337" }}>
                            {
                              buttonsLabel?.filter(
                                  (btn) => btn.UILabelProperty === "shiftProperty"
                                )[0]?.Label
                            }
                        </div>
                  
                    </ETStyledButton>
                  }
                  {/* { projectType === "poly" && pin !== 0  && (
                  <ETStyledButton
                  tabIndex = {"0"}
                  role     = "button"
                  variant  = {"secondary-1st-varient"}
                  isMobile = {isMobile}
                  pin      = {pin}
                  clr      = {clr}
                  >
                    <Status
                      pin      = {pin}
                      state    = {state}
                      setState = {setState}
                      isMobile = {isMobile}
                      {...{ percent: lowQualityPercent }}
                    />
                  </ETStyledButton>
                )} */}
                  </>
              }
              { config?.IMAGE_SNAPFRAMES?.length > 0 &&
                     
                      !showOldSlider && (
                <ETStyledButton
                  variant  = {"secondary-1st-varient"}
                  // tabIndex = {"0"}
                  // role     = "button"
                  pin      = {pin}
                  clr     = {clr}
                  onClick = {()=> {
                    if(rotatemode && isrotate) click1()
                    else click2()
                  }}
                >
                  <>
                    {!turnBuilding ? (
                      <>
                        <Icon
                          icon     = "rightarrowrotate"
                          color    = {pin > 0 || showButton ? "#004337" : "#004337"}
                          isFaIcon = {true}
                          skipColorChange={true}
                          size     = "lg"
                        />{" "}
                        <div
                          className = "eus-button-2"
                          style     = {{ color: "#004337" }}
                        >
                          {
                            buttonsLabel?.filter(
                              (btn) => 
                                btn?.UILabelProperty === "RoterModel"
                            )[0]?.Label
                          }
                        </div>
                      </>
                    ) : (
                      <>
                        <Icon
                       
                          icon     = {isrotate ? "pause" : "play"}
                          color    = {"#004337"}
                          isFaIcon = {true}
                          skipColorChange={true}
                          size     = "lg"
                        />{" "}
                        <p style = {{ color: "#004337" }}>
                          {isrotate
                            ? "Stop rotation"
                            : "Start rotation"}
                        </p>
                      </>
                    )}
                  </>
                </ETStyledButton>
              )}
              {/* { Boolean(raw.length) && projectType === "mono" && atModel && isMobile && (
                  <ETStyledButton
                  variant  = {"secondary-1st-varient"}
                  // tabIndex = {"0"}
                  // role     = "button"
                  pin      = {pin}
                  clr     = {clr}
                >
               <Status
                    pin      = {pin}
                    state    = {state}
                    setState = {setState}
                    isMobile = {isMobile}
                    {...{ percent: percent }}
                  />
                </ETStyledButton>
              )} */}
                  {/* { 
                  // atModel && 
                  isMobile &&
                    <ETStyledButton
                      variant  = {"secondary"}
                      isMobile = {isMobile}
                      pin      = {pin}
                      clr      = {clr}
                      onClick  = {()=> {
                        clickModel()
                          // Toggle the weather mode state
                          setSeasonMode(!iconRotated)
                          // Toggle icon rotation
                          setIconRotated(!iconRotated)
                          setWeatherMode(!iconRotated)
                          setIsTurnBuilding(!iconRotated)
                        if(!iconRotated) {
                          setIsrotate(true)
                          setRmode(true)
                        }else {
                          setRmode(false)
                          setIsrotate(false)
                        }
                      }}
                    >
                       <RotatingIcon icon      = 'sun' size = {'23'} color = {'#000'} rotated = {iconRotated} />
                       <div          className = "eus-button-2">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Soldiagram')[0]?.Label || "Sun Diagram"}</div>
                    </ETStyledButton>
                  } */}
              </Box>
              </Box>
            </Main>
          </>
        )}
      
      </AnimatePresence>
      { 
        isMobile && state && (
          <>
            <ColorLegend setState = {setState}/>
          </>
        )
      }
    </>
  );
};
const RotatingIcon = styled(Icon)`
  transition: transform 0.3s ease-in-out;

  ${(props) => props.rotated && `
    transform: rotate(90deg);
  `}
`;